/**  
 * NotificationListFetchService
 * Page/Class name   : TaskListForSingleTaskService
 * Author            :
 * Created Date      : 6-7-2020
 * Functionality     : constructor, componentDidMount , componentWillUnmount, getTweetRecords
 * Purpose           : api service page
**/
import {Component } from 'react';
// import {getEndPoint,getTokenFromLocStorage, callApi} from  '../../common_utilities/commonjsfunc';
// newly added axios
//import axios from 'axios';
import {axiosCustomObj} from '../customisedthirdparty/AxiosCustom';

import {commonJsFuncModule as commonJsObj} from  '../../common_utilities/commonjsfunc';
const callApi = commonJsObj.callApi;
const getTokenFromLocStorage = commonJsObj.getTokenFromLocStorage;
const getOffsetOfLocalDateTime = commonJsObj.getOffsetOfLocalDateTime;
const getMaxPageSize = commonJsObj.getMaxPageSize;


class NotificationListFetchService extends Component {

    
    /**  
     * NotificationListFetchService
     * Function name : constructor
     * Author        :
     * Created Date  : 6-7-2020
     * Purpose       : initializing state
     * Params        : 
    **/
    constructor() {
      super();
      this.state = {
          
      }

      //this.axiosObj = axios;
      this.axiosObj = null;
      
      this.apiEndPoint = commonJsObj.getEndPoint()+'rest/user/notifications';
    }

    /**  
     * TaskListForSingleTaskService
     * Function name : componentDidMount
     * Author        :
     * Created Date  : 6-7-2020
     * Purpose       : life cycle method
     * Params        : 
    **/
    componentDidMount() {
    }

    /**  
     * TypeOfProfessionalsService
     * Function name : componentWillUnmount
     * Author        :
     * Created Date  : 4-3-2020
     * Purpose       : life cycle method
     * Params        : 
    **/
    componentWillUnmount() {  
    }



    /**  
     * getNotificationList
     * Function name : getNotificationList
     * Author        :
     * Created Date  : 6-7-2020
     * Purpose       : Login check to provide access token 
     * Params        : paramObj
    **/
    async getNotificationList(paramObj){
      //console.log(" paramObj==>",paramObj);
      this.axiosObj = axiosCustomObj({});
      let accToken = getTokenFromLocStorage();   
      let offsetOfLocalDateTime = getOffsetOfLocalDateTime(new Date());

      try{
            let urldata =this.apiEndPoint; 

            let defaultPageSize = getMaxPageSize();
            let offsetHr = offsetOfLocalDateTime.hr;
            let offsetMin = offsetOfLocalDateTime.min;
            
            let paramObjData = paramObj.data;

            
            let pageNum = paramObjData.pageNum?paramObjData.pageNum:1;
            let pageSize = paramObjData.pageSize?paramObjData.pageSize:defaultPageSize;
           
            

            urldata = urldata+"/?offset_hour="+offsetHr+"&offset_minute="+offsetMin+"&page_number="+pageNum+"&page_size="+pageSize;
            

            //console.log("task single list api hitted with =>>",urldata);


            let headerOptn = {  
              "Content-Type": "application/json",
              "Authorization": accToken
            };          

            let respObj = this.axiosObj.get(urldata,{
            headers: headerOptn
            });

            return respObj;
    }
    catch(err){
        console.log("Some error occured===>",err); // TypeError: failed to fetch
    }
      

    }

    
}
export default NotificationListFetchService;